import useIsSsr from 'hooks/useIsSsr';
import React from 'react';
import { useUserJwtData } from '../AuthenticationProvider/AuthenticationProvider';
import {
  ConversionEvent,
  ConversionEventOptions,
  handleConversionEvent,
} from './trackingScriptEvents';

export function useConversionEventTrigger() {
  const userGuid = useUserJwtData()?.guid;
  return React.useCallback(
    (event: ConversionEvent, options?: ConversionEventOptions) => {
      handleConversionEvent(event, {
        userGuid,
        ...(options || {}),
      });
    },
    [userGuid],
  );
}

export function useOnConversionEvent(event: ConversionEvent, options?: ConversionEventOptions) {
  const trigger = useConversionEventTrigger();
  const fired = React.useRef(false);
  const isSsr = useIsSsr();
  React.useEffect(() => {
    if (!fired.current && !isSsr) {
      fired.current = true;
      trigger(event, options);
    }
  }, [event, options, isSsr, trigger]);
}
